import { Confirm, Alert, Toast, Loading } from 'base/dialog'

const $alert = (msg, option = {}) => {
  Alert(msg, option);
}

const $confirm = (msg, option = {}) => {
  Confirm(msg, option);
}

const toast = (msg, option = {}) => {
  if (msg) {
    option.mes = msg;
  }
  Toast(option);
}

export default {
  confirm: $confirm,
  alert: $alert,
  toast,
  loading: Loading
};
